import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import Maska from 'maska'
import VueCurrencyFilter from 'vue-currency-filter'
import 'vue-search-select/dist/VueSearchSelect.css'

import helper from './shared/Helper'


Vue.use(Maska)
Vue.config.productionTip = false
Vue.use(helper)
Vue.use(VueCurrencyFilter,{
  symbol: '', // El símbolo, por ejemplo €
  thousandsSeparator: ',', // Separador de miles
  fractionCount: 2, // ¿Cuántos decimales mostrar?
  fractionSeparator: '.', // Separador de decimales
  symbolPosition: '', // Posición del símbolo. Puede ser al inicio ('front') o al final ('') es decir, si queremos que sea al final, en lugar de front ponemos una cadena vacía ''
  symbolSpacing: false // Indica si debe poner un espacio entre el símbolo y la cantidad
 })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
